function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "cart") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3697",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 .844A.84.84 0 0 1 .84 0h1.594a1.961 1.961 0 0 1 1.772 1.125H18.6A1.4 1.4 0 0 1 19.95 2.9l-1.435 5.351a2.527 2.527 0 0 1-2.434 1.874H5.978l.189 1a.844.844 0 0 0 .826.686h10.1a.844.844 0 0 1 0 1.688h-10.1a2.521 2.521 0 0 1-2.476-2.057L2.71 1.916a.279.279 0 0 0-.277-.229H.84A.84.84 0 0 1 0 .844zm4.482 15.469A1.681 1.681 0 1 1 6.163 18a1.684 1.684 0 0 1-1.681-1.687zm11.766-1.687a1.688 1.688 0 1 1-1.681 1.688 1.684 1.684 0 0 1 1.682-1.689z",
    transform: "translate(2 3)",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCart);
export default __webpack_public_path__ + "static/media/cart.b41d96eb3779dd167d38a87c79bdea4f.svg";
export { ForwardRef as ReactComponent };